import { defineWidgetSettings } from "@nexus/widget-sdk";
import { ANIMATE_VALUE_CONFIG } from "@nexus/widget-kit";
import { DETAILS } from ".";

/** What an author sets on the blocking overview. */
export const settings = defineWidgetSettings({
  id: "blocking-overview",
  extends: [ANIMATE_VALUE_CONFIG],
  properties: {
    detail: {
      type: "string",
      title: "Detail",
      description: "Figures under the global ratio: ISP counts, or hours per blocking status",
      default: "isps",
      oneOf: DETAILS.map((option) => ({ const: option.value, title: option.label })),
      "x-ui": { category: "display", order: 10 },
    },
    showFlags: {
      type: "boolean",
      title: "Show country flags",
      description: "Shows each ISP's country flag in the ranking.",
      default: true,
      "x-ui": { category: "display", order: 11 },
    },
  },
});
